let Colors = require('material-ui/styles/colors');
let ColorManipulator = require('material-ui/utils/colorManipulator');
let Spacing = require('material-ui/styles/spacing');
let Typography = require('material-ui/styles/typography');

/* mirror these in style.scss to maintain consistency */
var primary = '#35A8E0';
var primaryDark = '#0288D1';
var secondary = '#333060';

var foregroundWhite = '#FAFAFA';
var foregroundBlack = '#212121';
var foregroundGrey = '#969696';
var foregroundLighterGrey = '#AAAAAA';
var foregroundLightestGrey = '#EBEBEB';

var white = '#FFFFFF';
var green = '#49A74C';
var red = '#FF4141';
var blue = '#35A8E0';
var orange = '#FD8E30';
var yellow = '#FFBD36';
var purple = '#9766D3';

var headlineTextSize = 24;
var headlineTextWeight = 300;

var buttonTextSize = 12;
var buttonTextSizeLarge = 14;
var buttonTextWeightLight = 300;
var buttonTextWeight = 400;
var buttonTextTransform = 'uppercase';

module.exports = {
  spacing: Spacing,
  fontFamily: 'Roboto, sans-serif',
  palette: {
    primary1Color: secondary,
    primary2Color: ColorManipulator.darken(orange, 0.3),
    primary3Color: ColorManipulator.lighten(secondary, 0.4),

    accent1Color: orange,
    accent2Color: primaryDark,
    accent3Color: '#000',

    textColor: foregroundBlack,
    alternateTextColor: foregroundWhite,
    disabledTextColor: foregroundGrey,

    canvasColor: Colors.white,
    borderColor: ColorManipulator.fade(foregroundGrey, 0.5),
    disabledColor: foregroundGrey,

    primary: primary,
    primaryDark: primaryDark,
    foregroundBlack: foregroundBlack,
    foregroundBlackFaded: ColorManipulator.fade(foregroundBlack, 0.5),
    foregroundWhite: foregroundWhite,
    foregroundWhiteFaded: ColorManipulator.fade(white, 0.5),
    foregroundGrey: foregroundGrey,
    red: red,
    green: green,
    yellow: yellow,
    purple: purple,
    white: white,
    blue: blue,
  },

  typography: {
    headlineTextSize: headlineTextSize,
    headlineTextWeight: headlineTextWeight,
  },

  drawer: {
    width: 300
  },

  button: {
    backgroundColor: {
      primary: secondary,
      primaryLight: white,
      secondary: 'transparent',
      secondaryLight: 'transparent',
      cta: orange,
      ctaSmall: orange,
    },
    labelColor: {
      primary: white,
      primaryLight: secondary,
      secondary: secondary,
      secondaryLight: white,
      cta: white,
      ctaSmall: white,
    },
    borderColor: {
      primary: secondary,
      primaryLight: white,
      secondary: secondary,
      secondaryLight: white,
      cta: orange,
      ctaSmall: orange,
    },
    fontSize: {
      primary: 12,
      primaryLight: 12,
      secondary: 12,
      secondaryLight: 12,
      cta: 14,
      ctaSmall: 12,
    },
  },
};



// WEBPACK FOOTER //
// ./app/theme.js